// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qgm5","title":"styles_title__2YzRd"};